import styled from 'styled-components';
import { theme } from '_constants/theme';
const { colors, devices, fontSizes, spaces } = theme;

const StyledSearchTrademarkGeniusProcessSection = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
  h1 {
    font-family: 'MontserratBold';
    font-style: normal;
    font-size: ${fontSizes.large}px;
    line-height: 130%;
    text-align: center;
    color: #394149;
  }
  p {
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.regular}px;
    line-height: 130%;
    text-align: center;
    color: #03589c;
    padding-left: 100px;
    padding-right: 100px;
  }
  @media ${devices.tablet} {
    padding-top: 20px;
    padding-left: 16px;
    padding-right: 16px;
    p {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`;

const SearchTrademarkGeniusProcessSection = () => {
  return (
    <StyledSearchTrademarkGeniusProcessSection>
      <h1>Trademark Genius Process</h1>
      <p>
        The Trademark Genius process makes it as easy as possible for your
        business to complete the trademark application. After you’ve performed
        many searches using the USPTO search, begin by completing a
        questionnaire that tells us more information about your business. We
        guarantee that all the information provided to us is safe, secure, and
        privacy protected.
      </p>
      <p>
        From here, the work is on us! Sit back and relax while our trademark
        application experts review the information you’ve provided. As experts
        in trademark applications, we know exactly what to look for and will let
        you know if information is missing. We conduct a direct-hit search to
        ensure the success of your application. We handle filing your
        application electronically with the USPTO.
      </p>
    </StyledSearchTrademarkGeniusProcessSection>
  );
};

export default SearchTrademarkGeniusProcessSection;
